var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showWorkingDays
    ? _c(
        "g",
        {
          staticClass: "gantt-elastic__chart-days-highlight-container",
          style: { ..._vm.root.style["chart-days-highlight-container"] },
        },
        _vm._l(_vm.workingDays, function (day) {
          return _c("rect", {
            key: _vm.getKey(day),
            staticClass: "gantt-elastic__chart-days-highlight-rect",
            style: { ..._vm.root.style["chart-days-highlight-rect"] },
            attrs: {
              x: day.offset.px,
              y: "0",
              width: day.width.px,
              height: "100%",
            },
          })
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }